import { createContext, useContext } from 'react'

const noop = () => ({})

export const Context = createContext({
  createIssue: noop,
  deleteIssue: noop,
  editIssue: noop,
  createAction: noop,
  editAction: noop,
  filters: [],
  pageData: {},
  handleStatic: noop(),
  batch: [],
  sortBy: [],
  onSort: noop(),
  masterBatch: null,
  setMasterBatch: noop(),
  compactView: false,
  setCompactView: noop(),
  search: '',
  setSearch: noop(),
  page: ''
})

export function IGAOContext ({ data, children }) {
  return (
    <Context.Provider value={data}>
      {children}
    </Context.Provider>
  )
}

export function useIGAO () {
  return useContext(Context)
}
